<app-alerts />

@if (data$ | async; as data) {
  <app-dictionary-details-form
    [data]="data"
    [hiddenControls]="['slug']"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
